import { ArrowUpRight, Instagram } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppFab";
import { Reveal } from "./Reveal";
import { Logo } from "./Logo";
import { whatsappLink, INSTAGRAM_URL, INSTAGRAM_HANDLE } from "../lib/site";

const Channel = ({ href, icon: Icon, label, value, id }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={id} className="group flex items-center justify-between gap-4 py-6 border-b border-white/10">
    <span className="flex items-center gap-4">
      <span className="grid place-items-center h-12 w-12 rounded-full border border-white/10 group-hover:border-[#D4AF5A]/60 transition-colors"><Icon size={18} className="text-gold" /></span>
      <span><span className="label block">{label}</span><span className="font-display text-xl sm:text-2xl font-semibold">{value}</span></span>
    </span>
    <ArrowUpRight className="text-[#A7A7AD] group-hover:text-[#D4AF5A] group-hover:rotate-45 transition-[transform,color] duration-500" />
  </a>
);

export const Contact = ({ onBrief }) => (
  <>
    <section id="contato" data-testid="contact-section" className="relative overflow-hidden border-t border-white/5">
      <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 bottom-[-40%] w-[120vw] h-[80vw] max-h-[900px] rounded-full bg-[radial-gradient(ellipse,rgba(212,175,90,0.12),transparent_60%)]" />
      <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 lg:py-40 grid lg:grid-cols-12 gap-14">
        <Reveal className="lg:col-span-7">
          <p className="label flex items-center gap-3 mb-8"><span className="font-mono text-gold">05</span><span className="h-px w-10 bg-[#D4AF5A]/50" />Vamos começar</p>
          <h2 className="font-display text-[2.4rem] sm:text-6xl lg:text-[5rem] font-semibold leading-[0.98] tracking-[-0.035em]">
            Sua marca merece um site <span className="font-serif italic font-normal text-gold">à altura</span>.
          </h2>
          <p className="mt-6 text-[#A7A7AD] max-w-md leading-relaxed">Responda um briefing rápido. Analisamos sua necessidade e retornamos pelo WhatsApp para conversar sobre o projeto.</p>
          <button onClick={onBrief} data-testid="final-cta-btn" className="btn-gold mt-10 h-14 px-8 rounded-full font-semibold text-[13px] tracking-[0.1em] uppercase inline-flex items-center gap-2">
            Solicitar um projeto <ArrowUpRight size={16} />
          </button>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5 lg:self-end border-t border-white/10">
          <Channel id="contact-whatsapp" href={whatsappLink("Olá! Vim pelo site da NEXUS e gostaria de conversar sobre um projeto.")} icon={WhatsAppIcon} label="WhatsApp" value="Conversar agora" />
          <Channel id="contact-instagram" href={INSTAGRAM_URL} icon={Instagram} label="Instagram" value={INSTAGRAM_HANDLE} />
        </Reveal>
      </div>
    </section>
    <footer data-testid="footer" className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pb-10 pt-6">
      <Logo className="flex text-[18vw] lg:text-[15rem] opacity-[0.07] leading-[0.8]" />
      <div className="mt-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#A7A7AD]">
        <span>© {new Date().getFullYear()} NEXUS® Design Digital</span>
        <span>Estúdio digital independente · Brasil</span>
      </div>
    </footer>
  </>
);
